import CourseTestPage from './CourseTestPage';
const Certification = () => {
    return (
        <>
            <CourseTestPage />
        </>
    );
}
export default Certification;